import { useContext } from 'react';
import { ErrorContext } from '../context/ErrorProvider/ErrorProvider';

export default function useExpressWidgetError() {
    return useContext(ErrorContext);
}
